/**
 * Vuex module for calls log
 */
import CallsLogStore from '@/api/callslog'

const actions = {
  callsLogDialed: {
    root: true,
    handler ({ commit, rootGetters }, num) {
      const currentUser = rootGetters['currentUser/currentUser']
      if (currentUser) commit('DIALED_CALL_ADD', { userId: currentUser.id, num })
    }
  },

  callsLogRecevd: {
    root: true,
    handler ({ commit, rootGetters }, { num, name }) {
      const currentUser = rootGetters['currentUser/currentUser']
      if (currentUser) commit('RECEVD_CALL_ADD', { userId: currentUser.id, num, name })
    }
  },

  callsLogMissed: {
    root: true,
    handler ({ commit, rootGetters }, { num, name }) {
      const currentUser = rootGetters['currentUser/currentUser']
      if (currentUser) commit('MISSED_CALL_ADD', { userId: currentUser.id, num, name })
    }
  },

  initCallsLog: {
    root: true,
    handler ({ commit, rootGetters }) {
      const currentUser = rootGetters['currentUser/currentUser']
      if (currentUser) commit('INIT_CALLS_LOG', currentUser.id)
    }
  },

  clearMissedCalls: {
    root: true,
    handler ({ commit, rootGetters }) {
      const currentUser = rootGetters['currentUser/currentUser']
      if (currentUser) commit('MISSED_CALL_CLEAR', currentUser.id)
    }
  },

  reset: function ({ commit }) {
    commit('RESET')
  }
}

function pushCall (call, list) {
  if (!call) {
    return
  }
  list.unshift(call)

  if (list.length > CallsLogStore.limit()) {
    list.pop()
  }
}

const mutations = {
  INIT_CALLS_LOG (state, userId) {
    state.calls = CallsLogStore.list(userId)
    state.missed = CallsLogStore.getMissedCalls(userId)
  },

  DIALED_CALL_ADD (state, { userId, num }) {
    const call = new CallsLogStore().storeDialed(userId, num)
    pushCall(call, state.calls)
  },

  RECEVD_CALL_ADD (state, { userId, num, name }) {
    const call = new CallsLogStore().storeReceived(userId, num, name)
    pushCall(call, state.calls)
  },

  MISSED_CALL_ADD (state, { userId, num, name }) {
    const call = new CallsLogStore().storeMissed(userId, num, name)
    pushCall(call, state.calls)
    state.missed++
  },

  MISSED_CALL_CLEAR (state, userId) {
    state.missed = 0
    CallsLogStore.clearMissed(userId)
  },

  RESET (state) {
    state.calls.splice(0)
    state.missed = 0
  }
}

const state = {
  calls: [],
  missed: 0
}

const getters = {
  filtered: state => num => {
    // fix special characters
    const pattern = num.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&')
    return state.calls.filter((c) => c.num.match(pattern))
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
